import React, { createContext, useContext, useState } from "react";
// import { initialFilter } from "./BuildingUIHelpers";

const BuildingUIContext = createContext();

export function useBuildingUIContext() {
  return useContext(BuildingUIContext);
}


export function BuildingUIProvider({ children }) {//,initialFilter
  // const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [buildingId, setBuildingId] = useState(null);
  const [floorId, setFloorId] = useState(null);

  const value = {
    buildingId,
    setBuildingId,
    floorId,
    setFloorId
  };

  return (
    <BuildingUIContext.Provider value={value}>
      {children}
    </BuildingUIContext.Provider>
  );
}
